module.exports = __webpack_public_path__ + "static/media/document.33db6c77.svg";